
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research",
      function () {
        return require("private-next-pages/research.js");
      }
    ]);
  